














































































































































































































































































































































































































































































































































































































































































































































































































































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";
import { Ref, Prop } from "vue-property-decorator";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";
import {
  CareSpecificationDetail,
  CareSpecification,
  PublicMoney,
  PublicMoneyDetail,
  AutoCompleteDetail
} from "@/components/careEdit/types";
import { SelectItem } from "@/types";
import DetailEditDialog from "@/components/careEdit/DetailEditDialog.vue";

@Component({
  components: {
    EditDayChangePicker,
    DetailEditDialog,
    NumberInput
  }
})
export default class CareSpecificationRev1 extends mixins(AxiosMixin) {
  @Prop() tab!: CareSpecification; //介護給付費データ
  @Prop() sex_items!: SelectItem[]; //性別選択アイテムリスト
  @Prop() stop_reason_items!: SelectItem[]; //中止理由選択アイテムリスト
  @Ref("editDialog") private readonly editDialog!: DetailEditDialog; //明細編集ダイアログ

  private editingIndex = -1; //編集中介護給付費明細番号
  private editingPm: PublicMoney | null = null; //編集中公費データ
  private editingSpecification: CareSpecification | null = null; //編集中介護給付費データ
  private selectPmItem = 0; //選択中の公費

  //明細行スタイル取得
  private getDetailHeightStyle(tab: CareSpecification): object {
    if (tab.specification_details.length == 1) {
      return {
        "min-height": "88px",
        position: "relative"
      };
    } else if (tab.specification_details.length == 2) {
      return {
        "min-height": "44px",
        position: "relative"
      };
    } else {
      return {
        position: "relative"
      };
    }
  }

  //明細行追加
  private open(specification: CareSpecification, pm: PublicMoney) {
    this.editingSpecification = specification;
    this.editingIndex = -1;
    this.editingPm = pm;
    this.editDialog.open(
      specification.id,
      specification.yearmonth,
      specification.office_ibow_unique_id
    );
  }

  //明細行編集
  private openUpdate(
    specification: CareSpecification,
    detail: CareSpecificationDetail,
    index: number,
    pm: PublicMoney
  ) {
    this.editingSpecification = specification;
    this.editingIndex = index;
    this.editingPm = pm;
    detail.public_money_count = this.editingPm.public_money_details[
      this.editingIndex
    ].public_money_count;
    detail.public_money_points = this.editingPm.public_money_details[
      this.editingIndex
    ].public_money_points;
    detail.summary = this.editingPm.public_money_details[
      this.editingIndex
    ].summary;
    this.editDialog.openUpdate(detail);
  }

  //明細行更新
  private updateDetail(detail: CareSpecificationDetail) {
    if (this.editingSpecification !== null && this.editingPm !== null) {
      if (this.editingIndex === -1) {
        this.editingSpecification.public_moneys.forEach(pm => {
          if (pm !== this.editingPm) {
            const pmd: PublicMoneyDetail = {
              id: 0,
              care_specification_id: pm.id,
              public_money_count: 0,
              public_money_points: 0,
              summary: ""
            };
            pm.public_money_details.push(pmd);
          }
        });
        const pmd: PublicMoneyDetail = {
          id: 0,
          care_specification_id: this.editingPm.id,
          public_money_count: Number(detail.public_money_count),
          public_money_points: Number(detail.public_money_points),
          summary: detail.summary
        };
        this.editingPm.public_money_details.push(pmd);
        this.editingSpecification.specification_details.push(detail);
      } else {
        const pmd: PublicMoneyDetail = {
          id: this.editingPm.public_money_details[this.editingIndex].id,
          care_specification_id: this.editingPm.id,
          public_money_count: Number(detail.public_money_count),
          public_money_points: Number(detail.public_money_points),
          summary: detail.summary
        };
        this.editingSpecification.specification_details.splice(
          this.editingIndex,
          1,
          detail
        );
        this.editingPm.public_money_details.splice(this.editingIndex, 1, pmd);
      }
    }
  }

  //明細行削除
  private deleteDetail() {
    if (this.editingSpecification !== null && this.editingPm !== null) {
      this.editingSpecification.specification_details.splice(
        this.editingIndex,
        1
      );
      this.editingSpecification.public_moneys.forEach(pm => {
        pm.public_money_details.splice(this.editingIndex, 1);
      });
    }
  }

  //自動計算
  private clickAutoComplete(tab: CareSpecification) {
    if (
      confirm(
        "給付費明細欄・④計画単位数・⑨単位数単価・保険/公費給付率に基づいて、集計欄の自動計算を行います。よろしいですか？\n※複数公費が登録されている場合、全ての公費の集計欄が自動計算の対象となります。"
      )
    ) {
      const details: AutoCompleteDetail[] = [];
      tab.specification_details.forEach((sd, index) => {
        const pmPoints = tab.public_moneys.map(pm => {
          return pm.public_money_details[index].public_money_points;
        });
        details.push({
          service_code: Number(sd.service_code),
          service_point: Number(sd.service_points),
          out_management_div: sd.out_management_div,
          public_money_points: pmPoints
        });
      });

      const pms = tab.public_moneys.map(pm => {
        return {
          public_money_self_burden: pm.public_money_self_burden,
          insurance_rate: Number(pm.insurance_rate),
          public_money_rate: Number(pm.public_money_rate)
        };
      });

      this.postJsonCheck(
        window.base_url + "/api/office/care/edit/auto_complete",
        {
          plan_points: Number(tab.specification_aggregates[0].plan_points),
          point_place: Number(tab.specification_aggregates[0].point_place),
          details: details,
          public_moneys: pms
        },
        res => {
          tab.specification_aggregates[0].target_points =
            res.data.target_points;
          tab.specification_aggregates[0].non_target_points =
            res.data.non_target_points;
          tab.specification_aggregates[0].payment_points =
            res.data.payment_points;
          tab.specification_aggregates[0].plan_points_above_money =
            res.data.plan_points_above_money;

          tab.public_moneys.forEach((pm, index) => {
            pm.public_money_aggregates[0].public_money_points =
              res.data.public_money_aggregates[index].public_money_points;
            pm.public_money_aggregates[0].ins_invoice =
              res.data.public_money_aggregates[index].ins_invoice;
            pm.public_money_aggregates[0].patient_burden =
              res.data.public_money_aggregates[index].patient_burden;
            pm.public_money_aggregates[0].public_money_invoice =
              res.data.public_money_aggregates[index].public_money_invoice;
            pm.public_money_aggregates[0].public_money_self_burden =
              res.data.public_money_aggregates[index].public_money_self_burden;

            pm.summary_insurance_money =
              res.data.public_money_aggregates[index].ins_invoice;
            pm.summary_patient_burden_money =
              res.data.public_money_aggregates[index].patient_burden;
            pm.summary_public_money =
              res.data.public_money_aggregates[index].public_money_invoice;
            pm.summary_public_money_patient_burden =
              res.data.public_money_aggregates[index].public_money_self_burden;
          });
        }
      );
    }
  }
}
